// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bc2867fd","455":"87a159f0","977":"0af9a886"}[chunkId] + ".chunk.js";
};